import React, { createContext, useContext, useEffect, useState } from 'react';
type RedirectContextType = {
    url?: string;
    setUrl: (url?: string) => void;
};

const RedirectContext = createContext<RedirectContextType | undefined>(undefined);
const redirectKey = "redirectUrl";

export const RedirectProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [url, setUrlState] = useState<string>();

    useEffect(() => {
        const redirectData = localStorage.getItem(redirectKey);
        if (redirectData) {
            setUrlState(redirectData);
        }
    }, []);

    // Update localStorage whenever player changes
    const setUrl = (newUrl: string | undefined) => {
        setUrlState(newUrl);
        if (newUrl) {
            localStorage.setItem(redirectKey, newUrl);
        } else {
            localStorage.removeItem(redirectKey);
        }
    };

    return (
        <RedirectContext.Provider value={{ url, setUrl }}>
            {children}
        </RedirectContext.Provider>
    );
};

export const useRedirect = () => {
    const context = useContext(RedirectContext);
    if (!context) {
        throw new Error('useRedirect must be used within a RedirectProvider');
    }
    return context;
};